import React, { useRef, useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Carousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import $ from 'jquery';
import { useNavigate } from 'react-router-dom';

function Access() {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Redirect to home if already authenticated
    useEffect(() => {
        const isAuthenticated = localStorage.getItem('gallery3_authenticated') === 'true';
        if (isAuthenticated) {
            navigate('/home', { replace: true });
        }
    }, [navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === 'BMX') {
            // Store authentication in localStorage
            localStorage.setItem('gallery3_authenticated', 'true');
            navigate('/home');
        } else {
            setError('Codice non valido');
            // Ensure authentication is cleared when wrong code is entered
            localStorage.removeItem('gallery3_authenticated');
        }
    };

    return (
        <div id="wrapper">
            

            <div className="no-bottom" id="content" style={{ padding: '0px' }}>
                <div id="top"></div>
                <header className="header-light scroll-light">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="de-flex sm-pt10">
                                <div className="de-flex-col">
                                    <div className="de-flex-col">
                                        <div id="logo">
                                            <a href="index.html">
                                                <img alt="" className="logo-2" src="/images/logosmall.png" width="200" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="de-flex-col header-col-mid">
                                    <img style={{ maxWidth: '400px', padding: '10px' }} src="/images/ue.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
                <section className="full-height relative no-top no-bottom vertical-center" data-bgimage="url(/images/comingbg.jpg) top" data-stellar-background-ratio=".5">
                    <div className="overlay-gradient t50">
                        <div className="center-y relative">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-lg-5 text-light wow fadeInRight" data-wow-delay=".5s">
                                        <div className="spacer-10"></div>
                                        <h1 style={{ 
                                            textShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)', 
                                            fontSize: '50px', 
                                            marginBottom: '2px', 
                                            lineHeight: '1.2em', 
                                            letterSpacing: '-1px' 
                                        }}>La piattaforma per vivere a <strong className="gold">360°</strong> il mondo dell'arte.</h1>
                                        <p className="lead" style={{ fontSize: '20px', lineHeight: '1.5em', textShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)' }}>La soluzione per artisti e gallerie d'arte che ridefinisce il possesso, l'esperienza e il valore dell'arte nell'era digitale.</p>
                                    </div>
                                    
                                    <div className="col-lg-4 offset-lg-2 wow fadeIn" data-wow-delay=".5s">
                                        <div className="box-rounded padding40" data-bgcolor="#ffffff" style={{ boxShadow: '10px 10px 15px rgba(0, 0, 0, 0.2)' }}>
                                            <h3 className="mb10">Area riservata</h3>
                                            <p>Accesso su invito per artisti, gallerie e collezionisti d'arte.</p>
                                            <form name="contactForm" id='contact_form' className="form-border" method="post" onSubmit={handleSubmit}>
                                                <p></p>
                                                
                                                <div className="field-set">
                                                    <input 
                                                        type='password' 
                                                        name='password' 
                                                        id='password' 
                                                        className="form-control" 
                                                        placeholder="Codice invito"
                                                        value={password}
                                                        onChange={(e) => {
                                                            setPassword(e.target.value);
                                                            setError(''); // Clear error when user types
                                                        }}
                                                    />
                                                </div>
                                                
                                                {error && (
                                                    <div className="error-message" style={{ color: 'red', margin: '10px 0' }}>
                                                        {error}
                                                    </div>
                                                )}
                                                
                                                <div className="field-set">
                                                    <input 
                                                        type='submit' 
                                                        id='send_message' 
                                                        value='Accedi' 
                                                        className="btn btn-main btn-fullwidth color-2" 
                                                        style={{ padding: '10px', background: '#000' }} 
                                                    />
                                                </div>
                                                
                                                <div className="clearfix"></div>
                                                
                                                <div className="spacer-single"></div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </div>
    );
}

export default Access;